import React from 'react';

function YouTube() {
  const youtubeUrl = decodeURIComponent(window.location.pathname.slice(9));

  return (
    <div className="youtube-container">
      <iframe
        width="560"
        height="315"
        src={`https://www.youtube.com/embed/${youtubeUrl}`}
        title="YouTube Video Player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default YouTube;
